var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": "welcome-dialog",
        fullscreen: "",
        persistent: ""
      },
      model: {
        value: _vm.show,
        callback: function($$v) {
          _vm.show = $$v
        },
        expression: "show"
      }
    },
    [
      _c("div", { staticClass: "background", style: _vm.backgroundImageUrl }, [
        _c(
          "div",
          { staticClass: "content" },
          [
            _c("login-component"),
            _vm._v(" "),
            _c("headlinesLight", {
              staticClass: "main",
              attrs: { category: "WelcomeBanner" }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footer" },
          [
            _c("static-content", {
              staticClass: "text",
              attrs: {
                staticcontentpath:
                  "/static/" + _vm.$i18n.locale + "/welcome/footer.html",
                method: "html",
                fullPath: ""
              }
            })
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a61001d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61001d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/WelcomeDialog.vue
// module id = null
// module chunks = 